export default __webpack_public_path__ + "digital-marketing.cd312513.jpeg";